import { Popup } from '../../../ui/popup/popup';
import { useEffect, useRef } from 'react';
import { BF_FREE_PLUGIN_QS_KEY } from './index';

interface IBlackFridayFreePluginPopup {
    popupHtml: string;
    width: number;
    height: number;
    closePopupCallback: () => void;
}

const BlackFridayFreePluginPopup = (props: IBlackFridayFreePluginPopup) => {

    const {  popupHtml, width, height, closePopupCallback } = props;
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {

        const _contentRef = contentRef;

        const handleClick = (evt: MouseEvent) => {
            const $target = evt.target as HTMLElement;
            if(!$target.hasAttribute('data-type') ||
                $target.getAttribute('data-type') !== 'cb-close') return;

            closePopupCallback();
        };

        contentRef.current?.addEventListener('click', handleClick);

        return () => {
            _contentRef.current?.removeEventListener('click', handleClick);
        };
    }, [ closePopupCallback ]);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete(BF_FREE_PLUGIN_QS_KEY);

        const newUrl = new URL(window.location.href);

        // @ts-ignore
        if(searchParams.size > 0) {
            newUrl.search = searchParams.toString();
        }
        else{
            newUrl.search = '';
        }

        if(window.location.hash !== '' && window.location.hash !== '#') {
            newUrl.hash = window.location.hash;
        }

        window.history.replaceState({}, '', newUrl);
    }, []);

    return (
        <Popup
            width={`${ width }px`}
            height={`${ height }px`}
            close={ () => {
                closePopupCallback();
        }}>
            <div
                ref={ contentRef }
                dangerouslySetInnerHTML={{ __html: popupHtml }} ></div>
        </Popup>
    )
};

export default BlackFridayFreePluginPopup;